import LoginError from './LoginError';
class UserAgentRequired extends LoginError {
    constructor(options) {
        super('The user agent header is required but was not provided', options);
    }
}
export default UserAgentRequired;
